module.exports = __webpack_public_path__ + "static/img/dz8.ba4761fb.png";